import { showToast } from '@slices/apiSlice';
import { baseApi } from '@store/baseQuery';

import { AcademicPayload, AcademicResponse, AcademicsResponse, DeleteResponse } from '../types';

export const academics = baseApi.injectEndpoints({
    endpoints: builder => ({
        addMentorAcademics: builder.mutation<AcademicResponse, AcademicPayload>({
            query: body => ({
                url: '/mentor/education',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info added successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        addMenteeAcademics: builder.mutation<AcademicResponse, AcademicPayload>({
            query: body => ({
                url: '/mentee/education',
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info added successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        getMentorAcademics: builder.query<AcademicsResponse, { username: string }>({
            query: args => ({
                url: `/mentor/${args.username}/education?offset=0&limit=100&orderBy=createdAt&orderDirection=DESC`,
                method: 'GET',
            }),
            providesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        getMenteeAcademics: builder.query<AcademicsResponse, { username: string }>({
            query: args => ({
                url: `/mentee/${args.username}/education?offset=0&limit=100&orderBy=createdAt&orderDirection=DESC`,
                method: 'GET',
            }),
            providesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        updateMentorAcademics: builder.mutation<
            AcademicResponse,
            { body: AcademicPayload; educationId: string }
        >({
            query: args => ({
                url: `/mentor/education/${args.educationId}`,
                method: 'PUT',
                body: args.body,
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info updated successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        updateMenteeAcademics: builder.mutation<
            AcademicResponse,
            { body: AcademicPayload; educationId: string }
        >({
            query: args => ({
                url: `/mentee/education/${args.educationId}`,
                method: 'PUT',
                body: args.body,
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info updated successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        deleteMentorAcademics: builder.mutation<DeleteResponse, { educationId: string }>({
            query: args => ({
                url: `/mentor/education/${args.educationId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info deleted successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
        deleteMenteeAcademics: builder.mutation<DeleteResponse, { educationId: string }>({
            query: args => ({
                url: `/mentee/education/${args.educationId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Education'],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(
                        showToast({
                            variant: 'success',
                            description: 'Academic Info deleted successfully',
                        })
                    );
                } catch (error) {
                    dispatch(showToast({ variant: 'error', description: error?.error }));
                }
            },
        }),
    }),
    overrideExisting: true,
});

export const {
    useAddMentorAcademicsMutation,
    useAddMenteeAcademicsMutation,
    useUpdateMentorAcademicsMutation,
    useUpdateMenteeAcademicsMutation,
    useLazyGetMentorAcademicsQuery,
    useLazyGetMenteeAcademicsQuery,
    useDeleteMentorAcademicsMutation,
    useDeleteMenteeAcademicsMutation,
} = academics;
